import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { AuthProvider } from '../features/auth/session'
import { ApiError } from '../lib/api'
import { router } from './router'
import { ToastProvider } from './toast'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 4xx will answer the same next time; only retry what may be passing.
      retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
})

/** The whole app: server data cache, session, toasts and pages. */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
